/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

import Vue from 'vue'
import jquery from 'jquery';
jquery.ajax({
  url: location.origin+'/static/config.json',
  type: 'GET', //GET
  async: false,    //或false,是否异步
  timeout: 10000,    //超时时间
  success: function (data, textStatus, jqXHR) {
    document.title = data.title
    for(let key in data){
      Vue.prototype[key] = data[key]
    }
  },
  error: function (xhr, textStatus) {
    console.error(textStatus);
  }
});
export const zuul = Vue.prototype.zuul
export const onlinePreview = Vue.prototype.onlinePreview
/* 项目名称 */
export const appName = Vue.prototype.appName;
/* 子公司项目名称 */
export const CappName = Vue.prototype.CappName;
//上传文件类型
export const fileType = Vue.prototype.fileType;
//项目编码
export const projectCode = Vue.prototype.projectCode;
// 看板mqtt地址
export const topologyMqttUrl = Vue.prototype.topologyMqttUrl;
// 看板websocket地址
export const topologyWebsocketUrl = Vue.prototype.topologyWebsocketUrl;
/**
 *宋建国：2019/11/24 0:45
 *描述：websocket配置
 *版本：1.0
 */
export const websocket = Vue.prototype.websocket;

export default {
  websocket,
  zuul,
  projectCode
}



// WEBPACK FOOTER //
// ./src/utils/global.js